<template>
  <validation-provider
    v-slot="{ errors, reset }"
    class="field validate-tooltip"
    :name="String(fieldName).toLowerCase()"
    :rules="{ required: { allowFalse: false }}"
    mode="eager"
  >
    <div
      v-for="(opt, index) in options"
      :key="index"
      class="control"
    >
      <radio
        v-model="localValue"
        v-bind="{ ...$props, ...$attrs }"
        :value="index"
        :true-value="index"
        v-on="$listeners"
      >
        <span v-html="opt" />
      </radio>
    </div>
    <transition name="fade">
      <span
        v-if="errors[0]"
        class="cell shrink error popover"
        tabindex="0"
        @click="reset()"
        v-text="errors[0]"
      />
    </transition>
  </validation-provider>
</template>

<script>
import Radio from '@/components/common/Radio';
export default {
  name: 'RadioGroupWithValidation',
  components: {
    Radio,
  },
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
  },
  props: {
    options: {
      type: [ Object ],
      default: () => {
        return {
          'option-1': 'Option 1',
          'option-2': 'Option 2',
          'option-3': 'Option 3',
        };
      },
    },
    rules: {
      type: [ String, Array, Object ],
      default: '',
    },
    modelValue: {
      type: [ String, Number, Boolean, Array ],
      default: '',
    },
  },
  computed: {
    fieldName() {
      return this.$attrs['data-vv-as'] || this.$attrs.title || this.$attrs.name;
    },
    localValue: {
      get() {
        return this.modelValue;
      },
      set(modelValue) {
        this.$emit('input', modelValue);
      },
    },
  },
};
</script>

<style>

</style>